var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoginBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2500 2000",
    style: {
      enableBackground: "new 0 0 2500 2000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#F5F4FF;}\n\t.st2{fill:#CCC2FF;}\n\t.st3{fill:#DDD6FF;}\n\t.st4{fill:#4F37B3;}\n\t.st5{fill:#E9E6FF;}\n\t.st6{fill:#7760DB;}\n\t.st7{fill:#FFE985;}\n\t.st8{fill:#FF95A9;}\n\t.st9{fill:#8B77E8;}\n\t.st10{fill:#B3A4F5;}\n\t.st11{fill:#C4B8FF;}\n\t.st12{fill:#F8F7FF;}\n\t.st13{fill:#40327A;}\n\t.st14{fill:#FFD259;}\n\t.st15{fill:#624AC9;}\n\t.st16{fill:none;}\n\t.st17{fill:#FFC7BD;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "back"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 2500,
    height: 2000
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M486.3,1744.3c-95.3-31.9-168.8-178.2-125.8-279.2c26.3-61.8,108.8-151.5,282.5-108.4 c41,10.2,109.4-4.1,109.4-43.1c0-61-135-117.6-135-257.7c0-114.3,60.2-214.2,237.5-214.2c260.5,0,357.5,288.1,552.7,288.1 c84.5,0,220.7-81.8,327.4-81.8c154.5,0,168.1,113,169.4,136.3c5.3,95.1-24.6,130.7-24.6,173.7c0,58.3,57.3,120.6,141.3,143.3 c206.5,56,162.3,199.1,76.3,243H486.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M659.9,666.8c-1.6-2.4-3.3-4.8-4.9-7.2l4.4-3c1.6,2.4,3.3,4.8,4.9,7.2L659.9,666.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M843.3,1004.4c-46.7-110.4-102-213.8-169.1-316.2l4.4-2.9c67.3,102.6,122.8,206.3,169.6,317L843.3,1004.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M984.8,1478.5c-35.7-175.7-78.3-320.6-134-456.1l4.9-2c55.9,135.8,98.5,281,134.3,457L984.8,1478.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M940.5,910.7c-1.5-13-16.1-22-47.2-18.4c-31.1,3.6-65.3,31.4-65.3,31.4s39.7,19.3,70.7,15.7 C929.8,935.8,942,923.7,940.5,910.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M569.5,563c-9.4,9.1-7.6,26.2,14.1,48.6s64.6,32.7,64.6,32.7s-8.9-43.2-30.6-65.6 C595.9,556.2,578.9,553.9,569.5,563z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M735.2,594c-12.7-3.3-26.3,7.1-34.2,37.4c-7.9,30.3,5.7,72.2,5.7,72.2s32.3-30,40.1-60.3 C754.8,613.1,747.9,597.3,735.2,594z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M795.2,675.6c-12.7-3.3-26.3,7.1-34.2,37.4c-7.9,30.3,5.7,72.2,5.7,72.2s32.3-30,40.1-60.3 C814.7,694.6,807.9,678.9,795.2,675.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M869.7,763.3c-10.5-7.8-27.1-3.3-45.7,21.7c-18.7,25.1-21.9,69-21.9,69s41.2-15.7,59.9-40.7 C880.6,788.3,880.2,771.1,869.7,763.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M559.7,705.1c-1.8,13,10.1,25.3,41,29.7c31,4.4,71.1-13.9,71.1-13.9s-33.5-28.7-64.5-33 C576.4,683.6,561.5,692.2,559.7,705.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M584.5,804.5c1.2,16.5,19.2,28.7,58.7,25.9s84.4-36.1,84.4-36.1s-49.1-26.6-88.6-23.8 C599.4,773.3,583.3,788,584.5,804.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M600.1,921.3c4.3,14,26.8,19.6,71.1,6.2c44.3-13.4,89.3-54.8,89.3-54.8s-60.4-9.5-104.7,4 C611.6,890.1,595.9,907.3,600.1,921.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M722.5,990.6c6.7,7.9,20.4,7.4,39.4-8.6s29.4-49.6,29.4-49.6s-34.8,4.7-53.7,20.8 C718.5,969.3,715.8,982.7,722.5,990.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M778.7,1089.9c12.2,4.2,26.4-4.9,36.5-34c10.1-29.1,0.1-71.3,0.1-71.3s-34.1,26.9-44.2,56 C761,1069.7,766.5,1085.7,778.7,1089.9z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 894.4,
    y: 1200.2,
    className: "st4",
    width: 5.3,
    height: 10.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 1694.7,
    cy: 483.2,
    r: 52.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1694.7,523.5c-22.2,0-40.3-18.1-40.3-40.3h5.3c0,19.3,15.7,35,35,35c19.3,0,35-15.7,35-35h5.3 C1734.9,505.4,1716.9,523.5,1694.7,523.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1683.1,468.9c0,7-2.8,12.6-6.3,12.6s-6.3-5.7-6.3-12.6c0-7,2.8-12.6,6.3-12.6S1683.1,462,1683.1,468.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1718.9,468.9c0,7-2.8,12.6-6.3,12.6s-6.3-5.7-6.3-12.6c0-7,2.8-12.6,6.3-12.6S1718.9,462,1718.9,468.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 156.3101 1543.8483)",
    className: "st7",
    cx: 1941.7,
    cy: 583.2,
    rx: 78.9,
    ry: 78.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1895.3,567.7l-5-1.6c4.2-12.7,13.8-20.6,25.3-20.6v5.3C1906.4,550.7,1898.8,557,1895.3,567.7z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st6",
    cx: 1915.6,
    cy: 580.6,
    rx: 7.7,
    ry: 15.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M2027.5,602.7c-6.4-6.4-16.7-6.4-23.1,0l0,0h0c-6.4-6.4-16.7-6.4-23.1,0c-6.4,6.4-6.4,16.7,0,23.1h0h0 l23.1,23.1l23.1-23.1l0,0l0,0C2033.9,619.4,2033.9,609.1,2027.5,602.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1996.5,569.5c-13.3-8.9-28.3-8-36.1-6.6l-0.9-5.2c8.6-1.5,25.2-2.5,40,7.4L1996.5,569.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1987,583.8c-11.9-8-27.5-3.1-27.6-3.1l-1.6-5c0.7-0.2,18.1-5.7,32.2,3.7L1987,583.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "1951.8,639.5 1948.8,635.2 1961,627 1951,620.2 1961,613.5 1948.8,605.3 1951.8,600.9 1970.3,613.4  1960.3,620.2 1970.3,627  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1602 -0.9871 0.9871 0.1602 877.8097 2710.2532)",
    className: "st3",
    cx: 2031.7,
    cy: 839.3,
    rx: 52.6,
    ry: 52.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1997.3,842.1l-3.8-3.6c3.6-3.8,8.5-6.3,13.8-7c5.2-0.7,10.6,0.4,15.2,3.1l-2.7,4.5c-3.6-2.1-7.6-3-11.7-2.4 C2003.8,837.2,2000.2,839.1,1997.3,842.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 2052.7,
    cy: 833.5,
    r: 17.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 2052.7,
    cy: 833.5,
    r: 6.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M2068.6,856.4c-3.5,11.7-11.7,21.1-22.2,25.7c-4.6,2-9.5,3.1-14.7,3.1c-5.2,0-10.2-1.1-14.7-3.1 c-10.5-4.6-18.7-14-22.2-25.7c6.8,2,14.3,3.4,22.2,4.2c4.8,0.5,9.7,0.7,14.7,0.7s10-0.3,14.7-0.7 C2054.3,859.8,2061.8,858.4,2068.6,856.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M2046.4,860.6v21.5c0,8.1-6.6,14.7-14.7,14.7c-8.1,0-14.7-6.6-14.7-14.7v-21.5c4.8,0.5,9.7,0.7,14.7,0.7 S2041.6,861.1,2046.4,860.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9239 -0.3827 0.3827 0.9239 -361.7742 306.051)",
    className: "st3",
    cx: 588.4,
    cy: 1062.4,
    rx: 59.2,
    ry: 59.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M630.8,1060.7c-9.8-6.5-20.9-5.9-26.6-4.9l-0.9-5.2c6.5-1.1,19.2-1.9,30.5,5.7L630.8,1060.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M623.6,1071.4c-8.7-5.8-20-2.3-20.2-2.2l-1.6-5c0.6-0.2,13.9-4.4,24.7,2.9L623.6,1071.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M588.4,1098c-6.5,0-12.5-3.4-15.9-9l4.5-2.7c2.4,4,6.7,6.4,11.4,6.4c4.7,0,8.9-2.4,11.3-6.4l4.5,2.7 C600.9,1094.6,595,1098,588.4,1098z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M551.5,1051.8l-5-1.6c3.2-9.8,10.7-15.9,19.6-15.9v5.3C559.5,1039.5,554,1044.1,551.5,1051.8z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st6",
    cx: 566.1,
    cy: 1061.3,
    rx: 5.8,
    ry: 11.6
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -749.4649 678.5793)",
    className: "st7",
    cx: 444.4,
    cy: 1244,
    rx: 78.9,
    ry: 78.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M426.3,1214.4c-6.4-3.5-14.4-1.1-17.9,5.3l0,0h0c-6.4-3.5-14.4-1.1-17.9,5.3c-3.5,6.4-1.1,14.4,5.3,17.9l0,0 l0,0l23.2,12.6l12.6-23.2l0,0v0C435.1,1225.9,432.7,1217.9,426.3,1214.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M462.4,1214.4c6.4-3.5,14.4-1.1,17.9,5.3l0,0h0c6.4-3.5,14.4-1.1,17.9,5.3c3.5,6.4,1.1,14.4-5.3,17.9l0,0l0,0 l-23.2,12.6l-12.6-23.2l0,0v0C453.7,1225.9,456,1217.9,462.4,1214.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M474.7,1271.3c-2.9,9.6-9.6,17.3-18.2,21.1c-3.7,1.7-7.8,2.6-12.1,2.6c-4.3,0-8.4-0.9-12.1-2.5 c-8.6-3.8-15.4-11.5-18.2-21.1c5.6,1.6,11.7,2.8,18.2,3.5c3.9,0.4,8,0.6,12.1,0.6c4.1,0,8.2-0.2,12.1-0.6 C463,1274.1,469.1,1272.9,474.7,1271.3z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2014.9,1227.8c33.6-10.3,112.8-83.4,49.9-121.3c-62.9-37.9-113.5,49.9-103.2,84.4 C1972,1225.4,1990.4,1235.3,2014.9,1227.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1499.7,1744.3L1499.7,1744.3H991.5v5.3h508.2c29,0,52.6-23.6,52.6-52.6v-234.1h-5.3v234.1 C1547,1723,1525.8,1744.3,1499.7,1744.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1547,
    y: 1408.1,
    className: "st4",
    width: 5.3,
    height: 11.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1547,
    y: 1055.9,
    className: "st4",
    width: 5.3,
    height: 335.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1547,
    y: 799.2,
    className: "st4",
    width: 5.3,
    height: 15.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1499.7,491.7c26.1,0,47.4,21.3,47.4,47.4v231.8h5.3V539c0-29-23.6-52.6-52.6-52.6h-466.8v5.3H1499.7 L1499.7,491.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1009.7,486.4H947c-29,0-52.6,23.6-52.6,52.6v635.4h5.3V539c0-26.1,21.2-47.4,47.4-47.4h0h62.7V486.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1547,539c0-26.1-21.2-47.4-47.4-47.4h0h-466.8h-23.1H947c-26.1,0-47.4,21.3-47.4,47.4v1157.9 c0,26.1,21.2,47.4,47.4,47.4h44.5h508.2h0c26.1,0,47.4-21.3,47.4-47.4v-234.1v-43.2v-11.5v-16.8v-335.4V815v-15.8v-28.4V539z  M1239.2,531.1c0,1.7-0.3,3.4-0.8,5h0c-1.4,4.2-4.6,7.7-8.6,9.4l-1.1-2.4c-1.6,0.7-3.4,1.1-5.3,1.1c-7.3,0-13.2-5.9-13.2-13.2 h-2.6c0-8.7,7.1-15.8,15.8-15.8C1232.1,515.3,1239.2,522.4,1239.2,531.1z M1344.9,1720.6v-2.6h-27v2.6h-10v-2.6h-181.6h-179H947 c-11.6,0-21.1-9.4-21.1-21.1v-25.4V647.6V555v-16l0,0c0-11.6,9.4-21.1,21.1-21.1h239.5v13.2c0,20.3,16.5,36.8,36.8,36.8 s36.8-16.5,36.8-36.8V518h239.5c11.6,0,21.1,9.4,21.1,21.1l0,0v16v21.8h2.6v158.3h-2.6v431.6h2.6v20.1h-2.6v20.4h2.6v489.6 c0,13.1-10.6,23.7-23.7,23.7H1344.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1518.1,656.8l-260.1,40.5h136.1c40.6,0,73.5,32.9,73.5,73.5v73.5h-36v2.6h-352.8c-22.4,0-43.6-9.8-58.1-26.9 l2-1.7c-5.5-6.5-9.9-14-12.9-22.2l-2.5,0.9c-1.5-4.2-2.7-8.6-3.5-13l2.6-0.5c-0.7-4.2-1.1-8.5-1.1-12.8l0,0 c0-12.9,3.3-25.1,9.2-35.6l-67.2,10.5v875l570.8-88.9v-324.4h2.6v-20.4h-2.6v-20.1h2.6V735.1h-2.6V656.8z M974.4,963.9 c0-42,34.2-76.2,76.2-76.2h315.3c20.4,0,39.5,7.9,53.9,22.3l-1.9,1.9c5.4,5.4,10,11.7,13.5,18.6l2.4-1.2c1.1,2.2,2.1,4.4,3,6.6 l-2.5,1c3.3,8.3,5.1,17.4,5.1,26.9v0c0,40.6-32.9,73.5-73.5,73.5h-31.7v2.6H1314v-2.6h-54.7v2.6h-190.9v-2.6h-20.2v2.6h-73.8 V963.9z M1380.1,1509.5c-4.5,0-8.2-3.7-8.2-8.2s3.7-8.2,8.2-8.2c4.5,0,8.2,3.7,8.2,8.2S1384.6,1509.5,1380.1,1509.5z  M1415.8,1509.5c-4.5,0-8.2-3.7-8.2-8.2s3.7-8.2,8.2-8.2c4.5,0,8.2,3.7,8.2,8.2S1420.3,1509.5,1415.8,1509.5z M1365.8,1426.3H1203 v-2.6h-16.7v2.6h-11.8v-2.6H977v-73.5c0-40.6,32.9-73.5,73.5-73.5h315.3c15.5,0,29.9,4.8,41.7,13l1.5-2.2 c20.6,14.2,32.9,37.7,32.9,62.7C1442,1392.2,1407.8,1426.3,1365.8,1426.3z M1451.5,1509.5c-4.5,0-8.2-3.7-8.2-8.2s3.7-8.2,8.2-8.2 s8.2,3.7,8.2,8.2S1456,1509.5,1451.5,1509.5z M1467.6,1230.6h-250.5v2.6h-17.8v-2.6h-25.9v2.6h-94.7c-42,0-76.2-34.2-76.2-76.2 c0-42,34.2-76.2,76.2-76.2h315.3c23.3,0,44.9,10.4,59.5,28.6l-2.1,1.7c10.1,12.6,16.1,28.5,16.1,45.9V1230.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "947.3,1668.2 1518.1,1579.3 1518.1,1552.2 947.3,1640.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1499.7,1715.3c10.2,0,18.4-8.3,18.4-18.4V1657l-378.2,58.9l-13.6,2.1h181.6v-2.6h10v2.6h27v-2.6H1499.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "1235.8,535.3 1235.8,535.3 1235.8,535.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1233.3,534.5l2.4,0.8l0,0L1233.3,534.5c0.4-1.1,0.5-2.2,0.5-3.3c0-5.8-4.7-10.5-10.5-10.5 c-5.8,0-10.5,4.7-10.5,10.5h-2.6c0,7.3,5.9,13.2,13.2,13.2c1.9,0,3.7-0.4,5.3-1.1l-1.1-2.4 C1230.3,539.6,1232.4,537.3,1233.3,534.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1223.4,515.3c-8.7,0-15.8,7.1-15.8,15.8h2.6h2.6c0-5.8,4.7-10.5,10.5-10.5c5.8,0,10.5,4.7,10.5,10.5 c0,1.1-0.2,2.3-0.5,3.3l2.4,0.8l0.1,0l-0.1,0l-2.4-0.8c-0.9,2.8-3,5.1-5.8,6.3l1.1,2.4l1.1,2.4c4.1-1.8,7.2-5.2,8.6-9.4h0 c0.5-1.6,0.8-3.3,0.8-5C1239.2,522.4,1232.1,515.3,1223.4,515.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1005.2,770.8c0,4.4,0.4,8.7,1.1,12.8l2.6-0.5c0.7,4.1,1.8,8.2,3.2,12.1l-2.5,0.9c3,8.2,7.4,15.6,12.9,22.2 l2-1.7c13.5,15.9,33.2,25.1,54.1,25.1h352.8v2.6h36v-73.5c0-40.6-32.9-73.5-73.5-73.5h-136.1h-179.2c-10.6,0-20.6,2.2-29.7,6.3 c9.1-4,19.1-6.2,29.7-6.2h179.1l-243.4,37.9c0,0,0,0,0,0C1008.6,745.7,1005.2,757.8,1005.2,770.8L1005.2,770.8z M1258.3,800.6 H1060v-5.3h198.4V800.6z M1060,773.4v-5.3h105.8v5.3H1060z M1296,773.4h-87.8v-5.3h87.8V773.4z M1332.2,773.4h-16.8v-5.3h16.8 V773.4z M1412.9,740.9v5.3H1060v-5.3H1412.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1014.5,735.1c0.7-1.3,1.5-2.5,2.3-3.8C1016,732.5,1015.2,733.8,1014.5,735.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1023.8,722c0.7-0.8,1.4-1.6,2.2-2.4C1025.2,720.4,1024.5,721.2,1023.8,722z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1020.5,725.9c0.7-0.9,1.5-1.9,2.3-2.8C1022,724.1,1021.2,725,1020.5,725.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1017.4,730.3c0.8-1.2,1.7-2.5,2.6-3.6C1019,727.9,1018.2,729.1,1017.4,730.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1008.9,783.2l-2.6,0.5l-2.6,0.5c0.8,4.4,1.9,8.8,3.5,13l2.5-0.9l2.5-0.9 C1010.8,791.3,1009.7,787.3,1008.9,783.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1078.8,841.7c-20.9,0-40.6-9.1-54.1-25.1l-2,1.7l-2,1.7c14.5,17.1,35.7,26.9,58.1,26.9h352.8v-2.6v-2.6 H1078.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1078.8,697.2c-10.6,0-20.6,2.2-29.7,6.2c-8.4,3.7-15.9,8.9-22.3,15.3c-0.3,0.3-0.5,0.6-0.8,0.8 c-0.7,0.8-1.5,1.5-2.2,2.4c-0.3,0.4-0.7,0.8-1,1.2c-0.8,0.9-1.5,1.8-2.3,2.8c-0.2,0.2-0.4,0.5-0.6,0.7c-0.9,1.2-1.7,2.4-2.6,3.6 c-0.2,0.3-0.4,0.6-0.6,1c-0.8,1.2-1.5,2.5-2.3,3.8c0,0,0,0.1-0.1,0.1l0,0l243.4-37.9H1078.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1365.8,893h-315.3c-39.1,0-70.9,31.8-70.9,70.9v70.9h68.5v2.6h20.2v-2.6h190.9v2.6h54.7v-2.6h20.1v2.6h31.7 c40.6,0,73.5-32.9,73.5-73.5v0c0-9.5-1.8-18.6-5.1-26.9l-2.4,1c-0.8-2.1-1.8-4.2-2.8-6.2l2.3-1.2c-3.5-6.9-8.1-13.2-13.5-18.6 l-1.9,1.9C1402.6,900.4,1384.8,893,1365.8,893z M1022.7,934h352.9v5.3h-352.9V934z M1022.7,961.3h80.3v5.3h-80.3V961.3z  M1221,993.8h-198.4v-5.3H1221V993.8z M1271,993.8h-23.3v-5.3h23.3V993.8z M1400.6,966.5H1147v-5.3h253.6V966.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1449.4,1112.8c-13.5-16.9-33.7-26.6-55.4-26.6h-315.3c-39.1,0-70.9,31.8-70.9,70.9s31.8,70.9,70.9,70.9 h94.7v2.6h25.9v-2.6h17.8v2.6h250.5V1157c0-17.4-6-33.3-16.1-45.9L1449.4,1112.8z M1060,1154.4h80.3v5.3H1060V1154.4z  M1258.3,1186.9H1060v-5.3h198.4V1186.9z M1156.6,1159.7v-5.3h18v5.3H1156.6z M1352.6,1132.4H1060v-5.3h292.6V1132.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1078.8,1227.9c-39.1,0-70.9-31.8-70.9-70.9s31.8-70.9,70.9-70.9h315.3c21.7,0,41.8,9.7,55.4,26.6l2-1.6 l2.1-1.7c-14.6-18.2-36.2-28.6-59.5-28.6h-315.3c-42,0-76.2,34.2-76.2,76.2c0,42,34.2,76.2,76.2,76.2h94.7v-2.6v-2.6H1078.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1365.8,1421.1c39.1,0,70.9-31.8,70.9-70.9c0-23.3-11.5-45.1-30.7-58.4l1.5-2.2c-11.9-8.2-26.2-13-41.7-13 h-315.3c-40.6,0-73.5,32.9-73.5,73.5v73.5h197.5v-2.6h11.8v2.6h16.7v-2.6H1365.8z M1283.5,1352.8h-121.7v-5.3h121.7V1352.8z  M1073.7,1320.3h301.9v5.3h-301.9V1320.3z M1022.7,1320.3h16.1v5.3h-16.1V1320.3z M1022.7,1347.5h99.2v5.3h-99.2V1347.5z  M1022.7,1380v-5.3H1221v5.3H1022.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1409.1,1287.4l-1.5,2.2l-1.5,2.2c19.2,13.3,30.7,35.1,30.7,58.4c0,39.1-31.8,70.9-70.9,70.9H1203v2.6v2.6 h162.8c42,0,76.2-34.2,76.2-76.2C1442,1325.1,1429.7,1301.7,1409.1,1287.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "1174.5,1421.1 1174.5,1423.7 1174.5,1426.3 1186.4,1426.3 1186.4,1423.7 1186.4,1421.1  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1022.7,
    y: 934,
    className: "st10",
    width: 352.9,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1147,
    y: 961.3,
    className: "st10",
    width: 253.6,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1022.7,
    y: 961.3,
    className: "st10",
    width: 80.3,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1247.7,
    y: 988.5,
    className: "st10",
    width: 23.3,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1022.7,
    y: 988.5,
    className: "st10",
    width: 198.4,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1073.7,
    y: 1320.3,
    className: "st10",
    width: 301.9,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1022.7,
    y: 1320.3,
    className: "st10",
    width: 16.1,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1161.8,
    y: 1347.5,
    className: "st10",
    width: 121.7,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1022.7,
    y: 1347.5,
    className: "st10",
    width: 99.2,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1022.7,
    y: 1374.8,
    className: "st10",
    width: 198.4,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1060,
    y: 740.9,
    className: "st6",
    width: 352.9,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1315.4,
    y: 768.2,
    className: "st6",
    width: 16.8,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1208.2,
    y: 768.2,
    className: "st6",
    width: 87.8,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1060,
    y: 768.2,
    className: "st6",
    width: 105.8,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1060,
    y: 795.4,
    className: "st6",
    width: 198.4,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1060,
    y: 1127.2,
    className: "st6",
    width: 292.6,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1060,
    y: 1154.4,
    className: "st6",
    width: 80.3,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1060,
    y: 1181.6,
    className: "st6",
    width: 198.4,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1156.6,
    y: 1154.4,
    className: "st6",
    width: 18,
    height: 5.3
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1199.3,1227.9 1199.3,1230.6 1199.3,1233.2 1217.1,1233.2 1217.1,1230.6 1217.1,1227.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "1068.4,1034.8 1068.4,1037.4 1068.4,1040.1 1259.3,1040.1 1259.3,1037.4 1259.3,1034.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1048.2,1037.4v-2.6h-68.5v-70.9c0-39.1,31.8-70.9,70.9-70.9h315.3c19,0,36.8,7.4,50.2,20.8l1.9-1.9l1.9-1.9 c-14.4-14.4-33.5-22.3-53.9-22.3h-315.3c-42,0-76.2,34.2-76.2,76.2v76.2h73.8V1037.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1431.8,937.9l2.4-1l2.5-1c-0.9-2.2-1.9-4.5-3-6.6l-2.4,1.2l-2.3,1.2C1430.1,933.8,1431,935.9,1431.8,937.9z "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "1314,1034.8 1314,1037.4 1314,1040.1 1334.1,1040.1 1334.1,1037.4 1334.1,1034.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "947.3,697.2 1518.1,609.2 1518.1,576.9 1520.7,576.9 1520.7,555 947.3,644.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "947.3,1640.2 1518.1,1552.2 1518.1,1531.7 947.3,1620.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1380.1,1493.1c-4.5,0-8.2,3.7-8.2,8.2s3.7,8.2,8.2,8.2c4.5,0,8.2-3.7,8.2-8.2S1384.6,1493.1,1380.1,1493.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1415.8,1493.1c-4.5,0-8.2,3.7-8.2,8.2s3.7,8.2,8.2,8.2c4.5,0,8.2-3.7,8.2-8.2S1420.3,1493.1,1415.8,1493.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1451.5,1493.1c-4.5,0-8.2,3.7-8.2,8.2s3.7,8.2,8.2,8.2s8.2-3.7,8.2-8.2S1456,1493.1,1451.5,1493.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1307.9,1715.3 1307.9,1718 1307.9,1720.6 1317.9,1720.6 1317.9,1718 1317.9,1715.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1523.4,1696.9v-489.6h-2.6h-2.6v324.4v20.5v27.1l-570.8,88.8v-27.9v-19.7v-875l67.2-10.5c0,0,0,0,0,0l0,0 c0,0,0-0.1,0.1-0.1c0.7-1.3,1.5-2.5,2.3-3.8c0.2-0.3,0.4-0.7,0.6-1c0.8-1.2,1.7-2.5,2.6-3.6c0.2-0.2,0.4-0.5,0.6-0.7 c0.7-0.9,1.5-1.9,2.3-2.8c0.3-0.4,0.7-0.8,1-1.2c0.7-0.8,1.4-1.6,2.2-2.4c0.3-0.3,0.5-0.6,0.8-0.8c6.4-6.4,14-11.6,22.3-15.3 c9.1-4,19.1-6.3,29.7-6.3h179.2l260.1-40.5v78.4h2.6h2.6V576.9h-2.6h-2.6v32.4l-570.8,88v-52.9l573.5-89.3v-16l0,0 c0-11.6-9.4-21.1-21.1-21.1h-239.5v13.2c0,20.3-16.5,36.8-36.8,36.8s-36.8-16.5-36.8-36.8V518H947c-11.6,0-21.1,9.4-21.1,21.1l0,0 v16v92.6v1023.9v25.4c0,11.6,9.4,21.1,21.1,21.1h0.2h179l13.6-2.1l378.2-58.9v39.9c0,10.2-8.3,18.4-18.4,18.4h-154.8v2.6v2.6 h154.8C1512.7,1720.6,1523.4,1710,1523.4,1696.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1518.1,1186.9 1520.7,1186.9 1523.4,1186.9 1523.4,1166.8 1520.7,1166.8 1518.1,1166.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1066,
    y: 172.2,
    className: "st10",
    width: 5.3,
    height: 13.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1066,
    y: 347.8,
    className: "st10",
    width: 5.3,
    height: 13.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1022.2,
    y: 184,
    transform: "matrix(0.8653 -0.5013 0.5013 0.8653 42.3603 539.4706)",
    className: "st10",
    width: 5.3,
    height: 13.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1109.9,
    y: 336,
    transform: "matrix(0.8664 -0.4994 0.4994 0.8664 -22.6053 601.4117)",
    className: "st10",
    width: 5.3,
    height: 13.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 990,
    y: 216.1,
    transform: "matrix(0.4993 -0.8664 0.8664 0.4993 303.7725 971.7617)",
    className: "st10",
    width: 5.3,
    height: 13.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1142,
    y: 303.9,
    transform: "matrix(0.4993 -0.8664 0.8664 0.4993 303.843 1147.411)",
    className: "st10",
    width: 5.3,
    height: 13.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 974,
    y: 264.3,
    className: "st10",
    width: 13.9,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1149.5,
    y: 264.3,
    className: "st10",
    width: 13.9,
    height: 5.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 985.7,
    y: 308.2,
    transform: "matrix(0.8664 -0.4994 0.4994 0.8664 -22.5803 537.2366)",
    className: "st10",
    width: 13.9,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1137.7,
    y: 220.4,
    transform: "matrix(0.8664 -0.4994 0.4994 0.8664 41.5622 601.4356)",
    className: "st10",
    width: 13.9,
    height: 5.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1017.8,
    y: 340.3,
    transform: "matrix(0.5011 -0.8654 0.8654 0.5011 214.5101 1057.9532)",
    className: "st10",
    width: 13.9,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1105.6,
    y: 188.3,
    transform: "matrix(0.4991 -0.8666 0.8666 0.4991 391.8619 1059.7244)",
    className: "st10",
    width: 13.9,
    height: 5.3
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M690.3,451.3c-10,0-19.8-5.2-25.1-14.5c-3.9-6.7-4.9-14.5-2.9-22c2-7.5,6.8-13.7,13.5-17.6 c13.8-8,31.6-3.2,39.5,10.6l0,0c8,13.8,3.2,31.6-10.6,39.5C700.2,450.1,695.2,451.3,690.3,451.3z M690.2,398.7c-4,0-8.1,1-11.8,3.2 c-5.5,3.2-9.4,8.3-11,14.4c-1.6,6.1-0.8,12.5,2.4,18c6.5,11.3,21,15.2,32.4,8.7c11.3-6.5,15.2-21,8.7-32.4l0,0 C706.4,402.9,698.4,398.7,690.2,398.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M2218.1,1502.9c-2.5,0-5-0.3-7.5-1c-7.5-2-13.7-6.8-17.6-13.5c-3.9-6.7-4.9-14.5-2.9-22 c2-7.5,6.8-13.7,13.5-17.6c6.7-3.9,14.5-4.9,22-2.9s13.7,6.8,17.6,13.5c8,13.8,3.2,31.6-10.6,39.5 C2228,1501.6,2223.1,1502.9,2218.1,1502.9z M2218,1450.2c-4.1,0-8.2,1.1-11.8,3.2c-5.5,3.2-9.4,8.3-11,14.4 c-1.6,6.1-0.8,12.5,2.4,18c3.2,5.5,8.3,9.4,14.4,11c6.1,1.6,12.5,0.8,18-2.4c11.3-6.5,15.2-21,8.7-32.4c-3.2-5.5-8.3-9.4-14.4-11 C2222.1,1450.5,2220,1450.2,2218,1450.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M440.2,946.3h-5.3c0-24.7-20.1-44.7-44.7-44.7v-5.3c24.7,0,44.7-20.1,44.7-44.7h5.3 c0,24.7,20.1,44.7,44.7,44.7v5.3C460.3,901.6,440.2,921.6,440.2,946.3z M406.2,898.9c14.7,5,26.4,16.6,31.3,31.3 c5-14.7,16.6-26.4,31.3-31.3c-14.7-5-26.4-16.6-31.3-31.3C432.6,882.3,420.9,893.9,406.2,898.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1741.7,1629.6c0,0,107.4-279.7,271.9-317.5c95-21.8,155.2,67.2,83.4,134.4 C1994.8,1542.2,1841.8,1529.7,1741.7,1629.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1893.8,1479.7l-3.3-4.1c49.5-39,101.5-71.5,142.6-89.3l2.1,4.8C1994.6,1408.7,1943,1441,1893.8,1479.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1875.2,1494.7l-3.4-4.1c2.9-2.4,5.7-4.7,8.6-7l3.3,4.1C1880.9,1490,1878.1,1492.4,1875.2,1494.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1704.9,1691.5l-4.6-2.5c38.3-71.5,98.7-133.6,142.5-173.2l3.5,3.9 C1802.7,1559.1,1742.8,1620.7,1704.9,1691.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1755.2,1662.7c0,0,58.5-17.1,119.9-12c92.6,7.6,146.5-12.2,149.2-41.3c1.7-19.2-18.9-44.9-91.3-33.5 C1887,1583.2,1825.4,1608.2,1755.2,1662.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1741.9,1672.4l-2.5-4.6c2.1-1.1,4.2-2.3,6.3-3.4l2.4,4.7C1746,1670.2,1743.9,1671.3,1741.9,1672.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1756.3,1664.9l-2.3-4.7c23.8-11.8,51.8-22.8,81-32l1.6,5C1807.6,1642.3,1779.8,1653.2,1756.3,1664.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1848.7,1629.6l-1.5-5.1c55-16,105.2-23,137.8-19.2l-0.6,5.2C1952.9,1606.9,1902.2,1614,1848.7,1629.6z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "_x2014_\\xCE\\xD3\\xC8_x5F_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M987.3,1786.4h560.9H987.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 987.3,
    y: 1783.8,
    className: "st11",
    width: 560.9,
    height: 5.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1705.3,1826.5h35.7H1705.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1705.3,
    y: 1823.9,
    className: "st11",
    width: 35.7,
    height: 5.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1410.2,1826.5h232.9H1410.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1410.2,
    y: 1823.9,
    className: "st11",
    width: 232.9,
    height: 5.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M815.4,1826.5h447.1H815.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 815.4,
    y: 1823.9,
    className: "st11",
    width: 447.1,
    height: 5.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M743.5,1826.5h37.7H743.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 743.5,
    y: 1823.9,
    className: "st11",
    width: 37.7,
    height: 5.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1814.3,1787h297.1H1814.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1814.3,
    y: 1784.4,
    className: "st11",
    width: 297.1,
    height: 5.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1614,1787h161.6H1614z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1614,
    y: 1784.4,
    className: "st11",
    width: 161.6,
    height: 5.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M363.1,1786.4h588H363.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.1,
    y: 1783.8,
    className: "st11",
    width: 588,
    height: 5.3
  })), /*#__PURE__*/React.createElement("rect", {
    x: 2236.8,
    y: 1744.3,
    className: "st11",
    width: 26.8,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.2,
    y: 1744.3,
    className: "st11",
    width: 1910.9,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.7,
    y: 1744.3,
    className: "st11",
    width: 59.6,
    height: 5.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M515.8,1746.9H840H515.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 515.8,
    y: 1744.3,
    className: "st13",
    width: 324.2,
    height: 5.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1251.7,1746.9l595.2,0L1251.7,1746.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1251.7,
    y: 1744.3,
    className: "st13",
    width: 595.2,
    height: 5.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1879.8,1746.9h25.9H1879.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1879.8,
    y: 1744.3,
    className: "st13",
    width: 25.9,
    height: 5.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M1012.4,1583.4c6.4-18.1,5.9-38.8-1.3-55.5c-5.7-13.3-14.9-25.1-28.2-35.9l-0.5-0.4 c-10.8-8.7-21.9-17.8-26.4-34.3c-5.4-19.5-3.9-31.2-2.5-42.4c1.5-11.6,2.9-22.5-3.7-41.9c-6.5-19.2-17.9-27.6-30-36.4 c-2.5-1.8-5.1-3.7-7.7-5.7c-17.4-13.5-16.9-35.2-16.3-62.7l0.1-5.9c0.2-9.1-1.2-23.4-4.1-32c-6.5-19.3-18.5-36.1-34.9-48.5 l1.6-2.1c-23.2-17.6-53.4-25.6-83.5-19.6c-60.5,12-97,72.4-80.9,130.8c3.1,11.2,7.9,21.5,14,30.6c0.6,0.9,1.2,1.8,1.8,2.7 c0,0,0,0,0,0c2.2,3.1,4.6,6.1,7.2,8.9c4.7,5.2,8.3,11.4,10,18.2c0,0.1,0,0.1,0,0.2c2.9,12.6,2,21.8-0.4,29.8c5.2-3,11-4.6,17-4.6 v0h0c0.1,0,0.3,0,0.4,0h18.6c0.1,0,0.1,0,0.2,0h16.2v0h6.9l-3.9-31.2l-5.3,0.6c-24.4,3-46.3-15.3-47.7-39.8l-4.1-68.8 c18.7-0.3,37.1,4.5,53.3,13.9l0,0c15.1,8.8,32.7,12.4,50,10.3l0,0l2.6-0.3c7.2-0.9,13.8,4.3,14.6,11.5l0,0 c0.9,7.2-4.3,13.8-11.5,14.6l-1.1,0.1l10.9,86.4h46.1c0.8,0,1.6,0,2.4,0.1c4.1,0.3,8.2,1.3,12,2.9c9.1,3.9,16.2,11.4,19.8,20.6 l0.1,0l0.9,2.7l8.7,28.9l-2.5,0.8l6.1,20.3l2.5-0.8l1.7,5.6l-2.5,0.8l4.1,13.7l2.5-0.8l28.4,94.7l-0.1,0c2.5,12-3.3,24.3-14.3,30 c-1.5,0.8-3.1,1.4-4.7,1.9l0,0.1l-2.7,0.6l-84.6,16.5c4,5,7.5,10.3,10.5,15.8h-50.6l0.8,4.9l-2.6,0.4l1.6,9.5h29.9l117.9-37.9l0,0 c0.8-0.3,1.7-0.5,2.6-0.7c8.1-1.8,16.2-0.1,22.7,4.1c6.5-7.6,11.1-15.9,14.2-24.5L1012.4,1583.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "905.6,1541.4 903.4,1536.4 905.8,1535.4 901.5,1525.1 899,1526.2 886.9,1497.7 868.4,1571.1  914.1,1554.7 908,1540.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M891.9,1230.5c2.9,8.5,4.2,22.8,4.1,32l-0.1,5.9c-0.6,27.5-1.1,49.2,16.3,62.7c2.6,2,5.1,3.8,7.7,5.7 c12.1,8.8,23.5,17.1,30,36.4c6.5,19.3,5.1,30.3,3.7,41.9c-1.4,11.3-2.9,22.9,2.5,42.4c4.6,16.5,15.7,25.5,26.4,34.3l0.5,0.4 c13.2,10.8,22.4,22.6,28.2,35.9c7.2,16.7,7.6,37.4,1.3,55.5l2.5,0.9l2.5,0.9c6.8-19.3,6.2-41.5-1.4-59.3 c-6.1-14.1-15.8-26.5-29.7-37.9l-0.5-0.4c-10.6-8.6-20.6-16.7-24.7-31.6c-5.1-18.5-3.7-29.6-2.3-40.3c1.5-11.7,3-23.7-3.9-44.2 c-7-20.8-19.1-29.6-31.9-38.9c-2.5-1.8-5-3.6-7.5-5.6c-15.3-11.9-14.9-31.4-14.3-58.4l0.1-5.9c0.2-9.8-1.2-24.5-4.3-33.7 c-6.8-20.3-19.5-37.9-36.7-51l-1.6,2.1l-1.6,2.1C873.3,1194.4,885.4,1211.2,891.9,1230.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M827.8,1628.5h50.6c-2.9-5.6-6.5-10.8-10.5-15.8l-41.4,8.1L827.8,1628.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M718.5,1471.3h7.7v2.6h18.6v-2.6h56.5l24.2,144.3l123.2-24l0,0l2.7-0.6c2.1-0.4,4.1-1.1,6-2.1 c9.5-4.9,14.2-15.9,11.1-26.1l-0.7-2.3l0,0l-27-90l2.5-0.8l-4.1-13.7l-2.5,0.8l-1.7-5.6l2.5-0.8l-6.1-20.3l-2.5,0.8l-8.7-28.8 c-2.7-9-9.2-16.2-17.7-19.9c-3.2-1.4-6.7-2.2-10.3-2.5c-0.7-0.1-1.3-0.1-1.9-0.1h-22.2l-88.8,58.2v-60.9h-16.2c-0.1,0-0.1,0-0.2,0 h-18.6c-0.1,0-0.3,0-0.4,0h0v0c-6,0-11.9,1.6-17,4.6c-6.2,3.6-11.3,9-14.4,16.1c-0.8,1.8-1.3,3.6-1.8,5.4l0,0l-17.6,71h25.5 V1471.3z M868.4,1571.1l18.5-73.4l-13.5-31.6l4.8-2.1l25.6,60.1l-2.4,1l4.4,10.2l2.4-1l2.2,5l-2.4,1l6.1,14.3L868.4,1571.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M868.1,1379.5h-23.2l-0.7-5.3l-10.9-86.4l1.1-0.1c7.2-0.9,12.4-7.4,11.5-14.6l0,0 c-0.9-7.2-7.4-12.4-14.6-11.5l-2.6,0.3l0,0c-17.4,2.1-34.9-1.5-50-10.3l0,0c-16.2-9.4-34.7-14.2-53.3-13.9l4.1,68.8 c1.4,24.5,23.3,42.8,47.7,39.8l5.3-0.6l3.9,31.2h-6.9v0v60.9L868.1,1379.5z M767.6,1320.5c-7,0.7-13.3-4.4-14-11.4l25.4-2.7 C779.7,1313.5,774.6,1319.8,767.6,1320.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M595,1604.8c0.9,0.2,1.7,0.4,2.6,0.7l0,0l15.9,5.1l214.1,32.7l0,0l-1.6-9.5l-2.6,0.4l-26.5-157.7h-52v-2.6 h-18.6v2.6h-7.7v-2.6H693H561.7l21.9,130.5C587.3,1603.8,591.1,1603.9,595,1604.8z M712,1558.6c1.6,9.6-4.8,17.3-14.4,17.3 c-9.6,0-18.6-7.8-20.2-17.3c-1.6-9.6,4.8-17.3,14.4-17.3C701.3,1541.3,710.4,1549.1,712,1558.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M677.3,1558.6c1.6,9.6,10.7,17.3,20.2,17.3c9.6,0,16-7.8,14.4-17.3c-1.6-9.6-10.7-17.3-20.2-17.3 C682.2,1541.3,675.7,1549.1,677.3,1558.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "613.5,1610.6 715.5,1643.3 827.6,1643.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M916.6,1743.8c0.1,0,0.2,0.1,0.2,0.1c1.3,0.3,2.5,0.4,3.8,0.4v0h35v0c8.9,0,16.3-6.8,17-15.8 c0.7-9.4-6.3-17.6-15.7-18.4c-0.4,0-0.9,0-1.3,0v0l-32.4,0h0L916.6,1743.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M649.7,1710.1l-32.4,0v0c-0.4,0-0.9,0-1.3,0c-9.4,0.7-16.5,8.9-15.7,18.4c0.7,9,8.2,15.8,17,15.8v0h35v0 c1.3,0,2.5-0.1,3.8-0.4c0.1,0,0.2,0,0.2-0.1L649.7,1710.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M977.9,1604.8c-0.9,0.2-1.7,0.4-2.6,0.7l0,0l-117.9,37.9h-29.9l0,0H715.5l-102-32.7l-15.9-5.1l0,0 c-0.8-0.3-1.7-0.5-2.6-0.7c-3.9-0.9-7.7-0.9-11.4-0.3c-11.6,1.9-21.5,10.6-24.2,22.8c-3,13.1,3.2,26.2,14.4,32.5l0,0l84.4,47.6 l-8.5,2.7l0,0l6.7,33.7l0,0l46.5-11.3c13.8,7.7,29.3,11.7,45.1,11.7l0-0.2c2.3,0.1,4.6,0.2,6.9,0.2H818c2.1,0,4.2-0.1,6.3-0.2v0.2 h0.6c15.8,0,31.3-4.1,45.1-11.7l46.5,11.3l0,0l6.7-33.7h0l-8.5-2.7l84.4-47.6l0,0c11.2-6.3,17.4-19.3,14.4-32.5 c-1.8-7.9-6.6-14.3-12.9-18.4C994.2,1604.6,986.1,1602.9,977.9,1604.8z M646.8,1675.8l26.8,6.5l-1.2,5.1l-26.8-6.5L646.8,1675.8z  M682.5,1689.9l1.2-5.1l121.7,29.4l-1.2,5.1L682.5,1689.9z M823.7,1724l1.2-5.1l8.4,2l-1.2,5.1L823.7,1724z M902.3,1706.1 l-143-45.9l1.6-5l143,45.9L902.3,1706.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "718.5,1471.3 718.5,1473.9 718.5,1476.5 726.2,1476.5 726.2,1473.9 726.2,1471.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "901.5,1525.1 903.9,1524.1 878.3,1464 873.4,1466.1 886.9,1497.7 899,1526.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "905.6,1541.4 908,1540.4 910.4,1539.4 908.2,1534.3 905.8,1535.4 903.4,1536.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "936.7,1456.8 939.3,1456.1 941.8,1455.3 940.1,1449.7 937.6,1450.4 935.1,1451.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M967.9,1560.5L967.9,1560.5l0.7,2.3c3.1,10.2-1.6,21.2-11.1,26.1c-1.9,1-3.9,1.6-6,2.1l-2.7,0.6l0,0 l-123.2,24l-24.2-144.3h-56.5v2.6v2.6h52l26.5,157.7l2.6-0.4l2.6-0.4l-0.8-4.9l-1.3-7.8l41.4-8.1l84.6-16.5l2.7-0.6l0-0.1 c1.6-0.5,3.2-1.1,4.7-1.9c11-5.7,16.8-18,14.3-30l0.1,0l-28.4-94.7l-2.5,0.8l-2.5,0.8L967.9,1560.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M844.9,1379.5h23.2h22.2c0.6,0,1.2,0,1.9,0.1c3.6,0.2,7.1,1.1,10.3,2.5c8.6,3.7,15,11,17.7,19.9l8.7,28.8 l2.5-0.8l2.5-0.8l-8.7-28.9l-0.9-2.7l-0.1,0c-3.6-9.2-10.6-16.6-19.8-20.6c-3.8-1.6-7.8-2.6-12-2.9c-0.8-0.1-1.6-0.1-2.4-0.1 h-46.1L844.9,1379.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 829,
    y: 1605.6,
    transform: "matrix(0.3057 -0.9521 0.9521 0.3057 -1022.7621 1958.7836)",
    className: "st2",
    width: 5.3,
    height: 150.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 657,
    y: 1667.9,
    transform: "matrix(0.2351 -0.972 0.972 0.2351 -1129.9902 1927.3508)",
    className: "st15",
    width: 5.3,
    height: 27.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 741.4,
    y: 1639.5,
    transform: "matrix(0.2351 -0.972 0.972 0.2351 -1085.2594 2025.0747)",
    className: "st15",
    width: 5.3,
    height: 125.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 825.9,
    y: 1718.2,
    transform: "matrix(0.235 -0.972 0.972 0.235 -1040.4569 2122.9771)",
    className: "st15",
    width: 5.3,
    height: 8.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M778.9,1306.5l-25.4,2.7c0.7,7,7,12.1,14,11.4C774.6,1319.8,779.7,1313.5,778.9,1306.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M1715,1465.2l50.1-106.9l-1.7,0.7l-41.3-97.2l2.4-1l-5.9-13.8l-2.4,1l-10.9-25.7l2.4-1l-5.9-13.8 c-9.9,5.8-20.9,9.9-32.9,11.8c-7.6,1.2-15.1,1.5-22.5,1l26.7,163.4c0,0,0,0,0,0c0,0,0,0,0,0l20,122l19.5-41.7L1715,1465.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1751.8,1142.3h-192.7l-0.5-2.2l0,0c0,0,0,0,0,0c0.5,3.1,1.2,6.1,2,9.1l5.5,25.7c0,0.1,0,0.2,0,0.3 c0.2,1.3,0.5,2.5,0.8,3.7l46,214.6c0,0,0,0,0,0h0l41.6,194.2l38.4-81.9l-20-122c0,0,0,0,0,0c0,0,0,0,0,0l-26.7-163.4 c7.4,0.5,14.9,0.2,22.5-1c12-2,23-6.1,32.9-11.8l5.9,13.8l2.4-1l10.9,25.7l-2.4,1l5.9,13.8l2.4-1l41.3,97.2l-3.1,1.3l-50.1,106.9 l2.4,1.1l-71.3,152.1l-2.4-1.1l-6.3,13.4l-6.6,14l2.4,1.1l-8.5,18.2l-2.4-1.1l-8.3,17.6l42.2,19.8l15.9-30.9l10.8,50.5v-2.1h44.4 c0-0.3,0-0.7,0-1c0-0.9-0.1-1.7-0.3-2.6l0,0l-18.8-115l116.7-226c0.5-0.8,0.9-1.6,1.3-2.5c3.8-8.2,3.7-17.1,0.4-24.8l0,0 L1751.8,1142.3l-2.7-24c-0.2-3.1-0.5-6.2-1.1-9.3c0,0,0,0,0,0l0,0L1751.8,1142.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1786.6,1077.2c6-3,10.8-7.4,14.2-12.7l0,0l67.4-103.8l0,0c2.1-3.2,3-7.3,2.3-11.4l-6.5-36.2 c-1.3-7-5.8-12.5-11.7-15.3c-3.8-1.8-8.2-2.5-12.7-1.7c-11.4,2.1-19,13-17,24.5c0.4,2,1,3.9,1.9,5.7l0,0l13.2,26.6l-0.2,0.1 l-50.1,36l-6.4-16.3l-45.1,28.7l7.6,66.9C1753.8,1080.5,1771.5,1084.6,1786.6,1077.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M1683.1,1718v2.1v24.2h66.8c3.6,0,6.6-3,6.6-6.6c0-2.4-1.3-4.6-3.4-5.8l-25.5-13.9h-0.1H1683.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M1598.9,1712.9c-1.4,3.1-2.1,6.4-2.1,9.6c0,8.5,4.8,16.7,13,20.5c11,5.2,24.1,0.7,29.7-10.1l16.7-32.4 l-42.2-19.8L1598.9,1712.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "1717.4,1466.3 1715,1465.2 1712.6,1464.1 1693.1,1505.8 1654.7,1587.7 1641.3,1616.2 1643.7,1617.3  1646.1,1618.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "1633.2,1645.9 1630.8,1644.7 1628.5,1643.6 1619.9,1661.8 1622.3,1663 1624.7,1664.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "1763.4,1359 1765.1,1358.3 1768.2,1356.9 1726.9,1259.7 1724.4,1260.7 1722,1261.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "1716.2,1248 1718.6,1247 1721,1245.9 1710.1,1220.2 1707.6,1221.2 1705.2,1222.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M1477.9,1003.4l49.4,7.3l195.6-94.7l0,0c1-0.5,2-0.8,3.1-1.1l-0.2-0.5l26.8-14.3l-11.1-28.3 c0-0.1-0.1-0.2-0.1-0.3l-0.1-0.3l0,0c-1.2-3.1-2.7-6.2-4.6-9.1c-10-15.7-27-24.3-44.4-24.3l0,0h-11.7 c-10,21.2-31.6,35.8-56.6,35.8c-23.9,0-44.7-13.5-55.2-33.2h-23.6c-19.9,0-37.8,11.7-45.8,29.9c-1.8,4-3,8.4-3.6,12.9l-0.5,3.6 l-0.1,0l-14.7,99l-2.6-0.4l-2,13.2l2.6,0.4L1477.9,1003.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M1824.4,926.2L1824.4,926.2c-0.9-1.8-1.5-3.6-1.9-5.7c-2.1-11.4,5.5-22.4,17-24.5c4.5-0.8,8.9-0.1,12.7,1.7 l9.7-44.8h-53.9l-21.6,99.9h51.1l0.2-0.1L1824.4,926.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1735.8,1001.3 1780.9,972.6 1767.5,938.4 1736.1,945 1545.1,1076.8 1551.4,1106.1 1558.7,1140.1  1558.7,1140.1 1559.2,1142.3 1751.8,1142.3 1748,1109.1 1748,1109.1 1743.4,1068.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1736.1,945l31.4-6.6l1.5-0.3c11.4-2.4,18.7-13.6,16.3-24.9c-2.4-11.4-13.6-18.7-24.9-16.3 c-2,0.4-3.9,1.1-5.6,2.1l0,0l-2.2,1.2l-26.8,14.3l0.2,0.5c-1.1,0.3-2.1,0.6-3.1,1.1l0,0l-195.6,94.7l-49.4-7.3l-1.7,11.5l-2.6-0.4 l-6.3,42.7l0,0c-2.3,15.6,5.9,31.4,21,38.1c11.8,5.2,24.9,3.5,34.8-3.4l0,0l21.9-15.1L1736.1,945z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1495.1,886.8L1495.1,886.8l0.6-3.6c0.6-4.5,1.9-8.8,3.6-12.9c8-18.1,25.9-29.9,45.8-29.9h23.6h11.7l0.5-5.3 h-35.8c-21.9,0-41.8,13-50.6,33c-1.5,3.4-2.6,7-3.4,10.7l-0.1-0.1L1475.3,985l2.6,0.4l2.6,0.4L1495.1,886.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1477.9,1003.4 1478.5,999 1475.9,998.6 1473.3,998.2 1471,1014.1 1473.6,1014.5 1476.2,1014.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1580.4,840.5h-11.7c10.5,19.7,31.2,33.2,55.2,33.2c25,0,46.5-14.7,56.6-35.8h-34.1l2.2-24.1l-4.8-0.4 c-21-1.9-36.6-20.5-34.7-41.5l4-44.6l0,0l0.4-3.9c0.7-7.9-5.1-14.9-13-15.6c-7.9-0.7-14.9,5.1-15.6,13c-0.7,7.9,5.1,14.9,13,15.6 l0,0l-3,33.8l-2.4-0.2c-1.9-0.2-3.6-0.6-5.3-1.1l-6.2,66.5L1580.4,840.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M1594.8,770.1l3-33.8l0,0c-7.9-0.7-13.7-7.7-13-15.6c0.7-7.9,7.7-13.7,15.6-13c7.9,0.7,13.7,7.7,13,15.6 l-0.4,3.9l0,0l-4,44.6c-1.9,21,13.6,39.6,34.7,41.5l4.8,0.4l33,3c10.9,1,20.4-7.4,20.9-18.3l1.9-47l0,0l-62.6-5.6 c-8.7-0.8-15.1-8.4-14.5-17l5.1-57.1c6.6,8.6,16.6,14.6,28.3,15.7l44,4c1.1,4.7,1.7,9.6,1.5,14.7l-0.5,12.3 c15.3-1.3,27.9-13.4,29.3-29.2c0.9-10.5-3.3-20.3-10.5-26.8c0.3-12.2-7.3-23-18.3-27.3c-1.9-0.9-4.1-1.5-6.3-1.7l-1.5-0.1 c0,0,0,0,0,0l-23.1-2.1v0l-2.4-0.2c-5.1-0.5-9.9,1.1-13.6,4.1c-3.1-4.7-8.2-8.1-14.3-8.6c-9.1-0.8-17.3,4.9-19.9,13.2 c-25-0.7-46.6,18.2-48.9,43.5l-3.1,34.9l0,0l-2.4,26.1c-1,11.3,6,21.4,16.3,24.8c1.7,0.6,3.5,1,5.3,1.1L1594.8,770.1z M1667,761.3 l28.9,2.4c-0.7,8-7.6,13.9-15.6,13.2C1672.3,776.2,1666.3,769.2,1667,761.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1706.3,705.9c0.2-5.1-0.3-10-1.5-14.7l-44-4c-11.7-1.1-21.7-7-28.3-15.7l-5.1,57.1 c-0.6,8.7,5.8,16.3,14.5,17l62.6,5.6l1.4-33.1L1706.3,705.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1680.2,776.9c8,0.7,15-5.3,15.6-13.2l-28.9-2.4C1666.3,769.2,1672.3,776.2,1680.2,776.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M872.9,1746.9h221H872.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 872.9,
    y: 1744.3,
    className: "st13",
    width: 221,
    height: 5.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1114.4,1746.9h29.4H1114.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1114.4,
    y: 1744.3,
    className: "st13",
    width: 29.4,
    height: 5.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M477.7,1746.9h-22H477.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 455.7,
    y: 1744.3,
    className: "st13",
    width: 22,
    height: 5.3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBackground);
export default __webpack_public_path__ + "static/media/login_background.7d64f4ec4f95c0de1ee1a7b7259b710f.svg";
export { ForwardRef as ReactComponent };